import styled from 'styled-components'

export const Container = styled.div<{ mode: 'form' | 'localization' }>`
  flex: 1;
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 24px;
  padding: 24px 16px;
  box-sizing: border-box;

  height: ${({ mode }) => (mode === 'form' ? 'auto' : '650px')};

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    gap: 16px;
    padding: 16px;
  }
`

export const DatePickerInput = styled.div`
  position: relative;
  cursor: pointer;
`

export const DatePickerContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`
export const LocalizationFormContainer = styled.div`
  display: flex;
  flex-direction: column;

  align-items: start;
  gap: 12px;
`

export const TextButtonLocalization = styled.button`
  color: var(--Foreground-Primary, #4d4be7);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  padding: 0;

  background: transparent;
  border: none;
  cursor: pointer;

  display: flex;
  gap: 8px;
  align-items: center;
`

export const TitleLocalization = styled.div`
  color: var(--Foreground-Neutral, #14171f);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`

export const ViewerContainer = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  position: relative;
  width: 100%;
  border-radius: 8px;
  border: 1px solid #dfe2ea;

  &::after {
    content: '';
    height: auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #4d4be7;
    opacity: 0;
    cursor: pointer;
  }

  * {
    cursor: pointer !important;
  }
`
